import { useAppStore } from "@/stores/appStore"
import { useAuthStore } from "@/stores/authStore"
import { canNavigate } from "@layouts/plugins/casl"
import { getSchoolStaff } from "@/services/ApiUrlService"
import { useCustomSwal } from "@/composables/usePopup"
import ReportService from "@/services/ReportService"

const CAMPAIGN = Number(import.meta.env.VITE_CAMPAIGN)
const allowedCampaignRoutes = [
  "profile", 
  "establishments", 
  "table-program", 
  "faq", 
  "help", 
]
const notAllowedCampaignRoutes = [
  "report-school-program-id"
]

export const setupGuards = async (router) => {
  router.beforeEach(async (to, from) => {
    const appStore = useAppStore()
    
    if (to.name === "campaign-id")
      useAppStore().yearSelected = to.params?.id || CURRENT_YEAR
    if (to.meta.public) return

    const isLoggedIn = !!(
      useCookie("user").value && useCookie("accessToken").value
    )
    const termsAccepted = useCookie("user").value?.termsAccepted

    if (to.meta.requiresAuth && !isLoggedIn) {
      return {
        name: "index",
        query: { to: to.fullPath, openLogin: "1" },
      }
    }

    if (CAMPAIGN === 1) {
      if (notAllowedCampaignRoutes.includes(to.name)) {
        return { path: "/not-authorized" }
      }
    }

    if (CAMPAIGN === 0) {
      if (allowedCampaignRoutes.includes(to.name)) {
        return { path: "/not-authorized" }
      }
    }
    
    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn) {
        console.log("is login page, and logged in")
        return { name: "home" }
      } else return undefined
    }
    // console.log(canNavigate(to), to)
    if (!canNavigate(to)) {
      if (isLoggedIn) {
        console.log("go to not authorized")
        return { name: "not-authorized", params: { "previous-page": to } }
      }
      return {
        name: "index",
        query: {
          ...to.query,
          to: to.fullPath !== "/" ? to.path : undefined,
        },
      }
    } else if (!isLoggedIn) {
      if (to.path.indexOf("/student/") !== -1) {
        return
      } else if (!useCookie("user").value && !useCookie("accessToken").value) {
        // && useCookie('userAbilityRules').value
        useAuthStore().logout()
      }
    } else if (isLoggedIn && !termsAccepted && to.name !== "reglement") {
      return { name: "reglement" }
    }
    async function getListReport() {
      try {
        const appStore = useAppStore()
        const response = await ReportService.listReport()

        appStore.setListReport = response
      } catch (error) {
          console.log(error)
      }
    }
    if (isLoggedIn) {
      const authStore = useAuthStore()

      if (!authStore.profileCache) {
        const schoolStaffId = useCookie("schoolStaffId").value
        const { data, error } = await useApi(
          `${getSchoolStaff}/${schoolStaffId}`
        )
        if (error.value) {
          authStore.logout()
        }
        authStore.setProfileUser(data.value)
      }
      if (+CAMPAIGN == 0) {
        await getListReport()
      }
    }
    // todo: clearRoute for cachedGetRequests
    const shouldBeClearedList = Object.keys(appStore.autoLoad).find((key) => {
      const config = appStore.autoLoad[key]
      return Array.isArray(config.clearRoute)
        ? config.clearRoute.includes(from.name)
        : config.clearRoute === from.name
    })
    if (shouldBeClearedList) {
      appStore.autoLoad[shouldBeClearedList].list = []
      appStore.autoLoad[shouldBeClearedList].touched = false
    }
  })
}
